// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yxXuz","right":"styles_right__2LzML"};